import axios from "axios";

const localBridgeUrl = (() => {
  // The local bridge is shared by the operator's Mac and trusted LAN clients.
  // Override this with window.__FK_LOCAL_LABEL_BRIDGE_URL__ or localStorage
  // when the Mac's address changes.
  // Open Labels is used from the operator's Mac, where the local bridge and
  // the seven logged-in Flipkart profiles run on loopback. Keep the LAN address
  // as an explicit override for a second device on the same network.
  const defaultUrl = "http://127.0.0.1:8766";
  try {
    const configured = typeof window !== "undefined" && (
      window.__FK_LOCAL_LABEL_BRIDGE_URL__
      || window.localStorage.getItem("fk_local_label_bridge_url")
    );
    return String(configured || defaultUrl).replace(/\/$/, "");
  } catch (_) {
    return defaultUrl;
  }
})();
const local = axios.create({ baseURL: localBridgeUrl, timeout: 16 * 60 * 1000 });

// All Open Labels surfaces share this response handler. No scan auth token is
// forwarded to localhost, and no request returns to the server worker.
export async function localLabelFallback(response) {
  if (!String(response.config?.url || "").match(/\/api\/label-(pdf|search)$/)) return response;
  const type = String(response.headers["content-type"] || "");
  if (!type.includes("application/json")) return response;
  const payload = response.data instanceof Blob ? JSON.parse(await response.data.text()) : response.data;
  const isFlipkartFallback = payload?.code === "FK_LOCAL_LABEL_FALLBACK";
  const isMyntraFallback = payload?.code === "MYNTRA_LOCAL_LABEL_FALLBACK";
  if (!isFlipkartFallback && !isMyntraFallback) return response;
  try {
    const endpoint = isMyntraFallback
      ? "/api/labels/myntra-local-fallback"
      : "/api/labels/flipkart-local-fallback";
    const { data } = await local.post(endpoint, {
      items: payload.items, archive_pdf: payload.archive_pdf,
    });
    if (!data.ok || !data.relpath || !data.pages) throw new Error(data.error || "No local PDF recovered");
    const pdf = await local.get("/api/archive/file", { params: { p: data.relpath }, responseType: "blob" });
    return { ...response, data: pdf.data, headers: { ...response.headers, "content-type": "application/pdf" } };
  } catch (error) {
    const message = error.response?.data?.error || error.message
      || `Cannot reach the local label console at ${localBridgeUrl}`;
    // Existing Open Labels components read errors as JSON blobs.
    throw Object.assign(new Error(message), {
      response: { status: error.response?.status || 503,
        data: new Blob([JSON.stringify({
          error: `Mac label fallback: ${message}. Open Labels must run from a browser that can reach the configured local label console (${localBridgeUrl}).`,
        })], { type: "application/json" }) },
    });
  }
}
